import React, { useState, useEffect } from 'react';
import styles from './LogoCreation.module.css';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import Logo1 from '../../images/Hyphen-Edge-Logo.jpg';
import Logo2 from '../../images/Pupa-Logo.jpg'
import Logo3 from '../../images/amy-parlour-logo.jpg'
import Logo4 from '../../images/Vox-Studio-Logo.jpg'
import Logo5 from '../../images/MT-Reality-Logo.jpg'
import Logo6 from '../../images/Sub-District-Kalolsav-2022.jpg'
import Logo7 from '../../images/IISTC.jpg'
import Logo8 from '../../images/Deepas-Makeover.jpg'

export default function LogoCreation() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const logos = [
    {
      id: 1,
      image: Logo1
    },
    {
      id: 2,
      image: Logo2
    },
    {
      id: 3,
      image: Logo3
    },
    {
      id: 4,
      image: Logo4
    },
    {
      id: 5,
      image: Logo5
    },
    {
      id: 6,
      image: Logo6
    },
    {
      id: 7,
      image: Logo7
    },
    {
      id: 8,
      image: Logo8
    }
  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      <div className={styles.pageWrapper}>
        {/* Animated Background */}
        <div className={styles.background}>
          <div className={`${styles.gradientOrb} ${styles.orb1}`} />
          <div className={`${styles.gradientOrb} ${styles.orb2}`} />
          <div className={`${styles.gradientOrb} ${styles.orb3}`} />
        </div>

        {/* Enhanced Floating Particles */}
        <div className={styles.particles}>
          {[...Array(30)].map((_, i) => (
            <div 
              key={i} 
              className={styles.particle}
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${12 + Math.random() * 15}s`,
                '--particle-x': `${Math.sin(i * 0.5) * 30}px`
              }}
            />
          ))}
        </div>

        {/* Main Content */}
        <div className={`${styles.content} ${isLoaded ? styles.loaded : ''}`}>
          <header className={styles.header}>
            <h1 className={styles.title}>
              <span className={styles.titleLine}>Logo Creation & Brand Identity</span>
            </h1>
            <div className={styles.titleDecoration} />
          </header>

          <article className={styles.description}>
            <p className={styles.paragraph}>
              Creating logos tailored for diverse sectors. Identifying client's key points. 
              Tailoring colors based on client's preferences. Crafting customized logos 
              reflecting brand essence.
            </p>
            <p className={styles.paragraph}>
              Providing unique branding solutions to resonate with each sector's audience. 
              All logos are created with the help of Illustrator, Photoshop and CorelDraw.
            </p>
            <p className={`${styles.paragraph} ${styles.highlight}`}>
              Explore our diverse portfolio of professional logo designs.
            </p>
          </article>

          {/* Logo Grid */}
          <section className={styles.logoGrid}>
            {logos.map((logo) => (
              <div
                key={logo.id}
                className={styles.logoCard}
              >
                <div className={styles.cardInner}>
                  <div className={styles.imageWrapper}>
                    <img 
                      src={logo.image} 
                      alt={`Logo ${logo.id}`}
                      className={styles.logoImage}
                      onClick={() => setSelectedImage(logo.image)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </section>
        </div>

        {/* Image Modal */}
        {selectedImage && (
          <div className={styles.imageModal} onClick={() => setSelectedImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeButton} onClick={() => setSelectedImage(null)}>
                ×
              </button>
              <img src={selectedImage} alt="Full size logo" className={styles.modalImage} />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}